var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"titulo":"Administração","breadcrumb":_vm.bread,"icone":"settings"}},[_c('TabelaAdministracao')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }